import icon from "../../assets/keyfob.svg";
import type { Property } from "../../types";

export const includedAccessories: Property = {
  id: "includedAccessories",
  title: "includedAccessories.title",
  icon,
};
